import React from 'react';
import { Page, Text, View, Document, Image, StyleSheet } from '@react-pdf/renderer';
import PDFModelPage from './PDFModelPage';

// Create styles
const styles = StyleSheet.create({
    page: {
        width: '100%',
        flexDirection: 'column',
        backgroundColor: '#ffff',
        padding: 40,
        alignContent: 'center',
    },
    section: {
        marginBottom: 20,
    },
    modelname: {
        padding: 5,
        flexDirection: 'column',
        textAlign: 'left',
        width: '100%',
        fontSize: 10,
        marginBottom: 20,
    },
});

// Create Document Component
const PDFModel = ({ model, assets }) => (
    <Document>
        {/* Title Page */}
        <Page size="A4" orientation="landscape" style={styles.page}>
            <View style={styles.section}>
                <View style={styles.modelname}>
                    <Text>{model.firstName || 'N/A'}</Text>
                    <Text>{model.lastName || 'N/A'}</Text>
                    <Text>{`Id: ${model.internalId || 'N/A'}`}</Text>
                </View>
            </View>
        </Page>

        {/* One page model with up to 8 images */}
        <PDFModelPage model={model} assets={assets} />
    </Document>
);

export default PDFModel;
